import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { QrCode, PauseCircle, SearchX } from "lucide-react";

export default function Gone() {
  const [sp] = useSearchParams();
  const reason = sp.get("reason");
  const map = {
    paused: { icon: PauseCircle, title: "Contenuto temporaneamente non disponibile", desc: "Questo QR code è stato messo in pausa dal proprietario. Riprova più tardi." },
    notfound: { icon: SearchX, title: "Contenuto non trovato", desc: "Il QR code non è più attivo o è stato rimosso." },
    empty: { icon: SearchX, title: "Destinazione non configurata", desc: "Questo QR non ha ancora una destinazione." },
  };
  const info = map[reason] || map.notfound;
  const Icon = info.icon;
  return (
    <div className="min-h-screen hero-gradient grid place-items-center px-6">
      <div className="text-center max-w-md">
        <span className="inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-white card-shadow text-muted-foreground mb-5"><Icon className="h-8 w-8" /></span>
        <h1 className="font-display text-2xl font-extrabold">{info.title}</h1>
        <p className="text-muted-foreground mt-2">{info.desc}</p>
        <Link to="/" className="mt-6 inline-flex items-center gap-1.5 text-primary font-semibold"><QrCode className="h-4 w-4" /> Scopri Qora</Link>
      </div>
    </div>
  );
}
